<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="ثريا">
<h1><span dir="rtl">ثريا</span></h1>
<p style="text-align: center;"><span dir="rtl">ثريَّا فتاة في نهاية العشرينيَّات مِن عمُر الزهور..</span></p>
<p style="text-align: center;"><span dir="rtl">تمشي بخِفَّة، تتأمَّل كلَّ شيء حولها بعينِ مُحبٍّ..</span></p>
<p style="text-align: center;"><span dir="rtl">تعيش في هدوء..</span></p>
<p style="text-align: center;"><span dir="rtl">تقضي أغلب الوقت بالقراءة والكتابة بتلك الصفحات.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0bbb5fa7